import React from 'react'

export const KYC_SELFIE_EXAMPLE_SRC = '/kyc/selfie-with-id-example.jpg'

export const KycSelfieExample: React.FC = () => {
  return (
    <div
      style={{
        marginBottom: '16px',
        padding: '12px',
        backgroundColor: 'rgba(17, 24, 39, 0.7)',
        border: '1px solid #fbbf24',
        borderRadius: '8px'
      }}
    >
      <div
        style={{
          display: 'inline-block',
          marginBottom: '8px',
          padding: '2px 8px',
          borderRadius: '999px',
          backgroundColor: '#fbbf24',
          color: '#111827',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.04em'
        }}
      >
        EXAMPLE
      </div>
      <img
        src={KYC_SELFIE_EXAMPLE_SRC}
        alt="Example selfie: hold your ID document next to your face"
        style={{
          display: 'block',
          width: '100%',
          maxWidth: '360px',
          height: 'auto',
          borderRadius: '8px',
          backgroundColor: '#ffffff'
        }}
      />
      <p style={{ color: '#fde68a', fontSize: '13px', margin: '8px 0 0 0' }}>
        Hold your ID next to your face in the same photo. A face-only passport photo will be rejected.
      </p>
    </div>
  )
}